import { Result, failure, success } from '../shared'
import { RatesProvider } from './rates.provider'
import {
  RatesServiceErrorCode,
  RatesFailure,
  GetRatesAttributes,
  AddCommercialRateAttributes,
  AddNBGRateAttributes,
  DeleteNBGRateAttributes,
  DeleteCommercialRateAttributes,
} from './rates.types'

export class RatesService {
  constructor(private provider: RatesProvider) {}

  public async get<T>(attributes: GetRatesAttributes): Promise<Result<T, RatesFailure>> {
    try {
      const { data } = await this.provider.get<T>(attributes)
      return success(data)
    } catch (error) {
      return failure(RatesServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async addNBGRate(attributes: AddNBGRateAttributes): Promise<Result<void, RatesFailure>> {
    try {
      await this.provider.addNBGRate(attributes)
      return success()
    } catch (error) {
      return failure(RatesServiceErrorCode.GENERAL, {
        message: error.Message || error.Text || 'HINT_ERR_TITLE',
      })
    }
  }

  public async deleteNBGRate(attributes: DeleteNBGRateAttributes): Promise<Result<void, RatesFailure>> {
    try {
      await this.provider.deleteNBGRate(attributes)
      return success()
    } catch (error) {
      return failure(RatesServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async addCommercialRate(attributes: AddCommercialRateAttributes): Promise<Result<void, RatesFailure>> {
    try {
      await this.provider.addCommercialRate(attributes)
      return success()
    } catch (error) {
      return failure(RatesServiceErrorCode.GENERAL, {
        message: error.Message || error.Text || 'HINT_ERR_TITLE',
      })
    }
  }

  public async deleteCommercialRate(attributes: DeleteCommercialRateAttributes): Promise<Result<void, RatesFailure>> {
    try {
      await this.provider.deleteCommercialRate(attributes)
      return success()
    } catch (error) {
      return failure(RatesServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
